import { updateSession } from '../../lib/funnels/functions/v1/default/updateSession'
import { loadGTM } from '../../lib/funnels/functions/v1/default/gtm'
import { loadSentry } from '../../lib/funnels/functions/v1/default/loadSentry'
import { getFunnelCache } from '../../lib/funnels/functions/v1/default/getFunnelCache'
import { getLoc } from '../../lib/funnels/functions/v1/middleware/getLoc'
import { queryParamsToSession } from '../../lib/funnels/functions/v1/default/queryParamsToSession'
import { setUpFormInputs } from '../../lib/funnels/functions/v1/html/setupFormInputs'
import { getDataFromSubmitEvent } from '../../lib/funnels/functions/v1/default/getDataFromSubmitEvent'

import './index.css'
import { checkInputValidity } from '../../lib/funnels/functions/v1/html/checkInputValidity'
import { checkSelectValidity } from '../../lib/funnels/functions/v1/html/checkSelectValidity'

const SESSION_ID = 'cdrFunnel'
/** @type {"yes" | "no"} */
let actively_paying = 'yes'
queryParamsToSession(SESSION_ID)

/**
 * Get location info
 */
async function runGetLoc() {
  try {
    const loc = await getLoc()
    // @ts-ignore
    if (loc.region) {
      // @ts-ignore
      updateSession(SESSION_ID, 'state', loc.region)
      // @ts-ignore
      updateSession(SESSION_ID, 'ip', loc.remoteAddress)
      document.getElementById('state-select')?.classList.add('hide')
    }
  } catch (error) {
    console.error(error)
  }
}

runGetLoc()

/**
 * Get query params from url by key
 * @param {string} key - The key
 * @returns {string | null} - The query param value
 */
function getQueryParams(key) {
  const url = new URL(window.location.href)
  return url.searchParams.get(key)
}

/**
 * @param {string[]} fields
 */
function fillFormFromQueryParams(fields) {
  fields.forEach((field) => {
    const value = getQueryParams(field)
    if (value) {
      const input = document.querySelector(`[name="${field}"]`)
      if (input) {
        // @ts-ignore
        input.value = value
        input.dispatchEvent(new Event('input', { bubbles: true }))
      }
    }
  })
}

/**
 * show section
 * @param {HTMLElement | null} el
 */
const show = (el) => {
  if (!el) return
  el.classList.remove('hide')
  requestAnimationFrame(() => el.classList.add('show'))
}

/**
 * hide section
 * @param {HTMLElement | null} el
 */
const hide = (el) => {
  if (!el) return
  el.classList.add('hide')
  el.classList.remove('show')
}

window.addEventListener('load', () => {
  loadGTM('GTM-KZ525569')
  loadSentry(
    'https://2c1906e7cc127780564b33c5e6f02954@sentry.turbodevhub.com/14',
  )

  updateSession(SESSION_ID, 'referrer', document.referrer)
})

document.addEventListener('DOMContentLoaded', async () => {
  /** @type {'30001' | '15000' | '0'} */
  let debtOwed = '30001'
  setUpFormInputs()

  const steps = ['step1', 'step2', 'step3', 'step4', 'step5']
  const [step1, step2, step3, step4, step5] = steps.map((step) =>
    document.getElementById(step),
  )

  show(step1)

  const dots = document.querySelectorAll('.header .dot')

  /**
   * set progress dots
   * @param {number} i - index
   */
  function setProgress(i) {
    dots.forEach((d) => d?.classList.remove('active'))
    if (dots[i - 1]) dots[i - 1]?.classList.add('active')
    let dotArray = Array.from(dots).slice(0, i - 1)
    dotArray.forEach((d) => {
      d.classList.add('filled')
    })
  }

  // @ts-ignore
  window.paysMoreThan20k = function paysMoreThan20k(val) {
    // if yes, trigger next step
    // if (val === 'yes') {
    if (val === 'no') {
      debtOwed = '15000'
    }
    hide(step1)
    show(step2)
    setProgress(2)
    startLoader()
    // return
    // }
    // if no, go to softpull flow - this was changed per Helena
    // window.location.href = `https://funnels.turbodebt.com/eligibility/1/?funnel=cdr-softpull&debtOwed=15001&${window.location.search.replace('?', '')}`
  }

  // @ts-ignore
  window.changeIsActivelyPaying = function changeIsActivelyPaying() {
    actively_paying = 'no'
    transitionToVerify()
  }

  // @ts-ignore
  window.isActivelyPaying = function isActivelyPaying() {
    transitionToVerify()
  }

  function transitionToVerify() {
    hide(step2)
    show(step3)
    window.setTimeout(() => {
      hide(step3)
      show(step4)
    }, 2100)
  }

  function startLoader() {
    const checks = [
      document.getElementById('check1'),
      document.getElementById('check2'),
      document.getElementById('check3'),
    ]
    checks.forEach((c) => {
      if (c) {
        c.classList.add('hide')
        c.classList.remove('done', 'show')
      }
    })
    setTimeout(() => {
      const c = checks[0]
      if (c) {
        c.classList.remove('hide')
        requestAnimationFrame(() => {
          c.classList.add('show', 'done')
        })
      }
    }, 70)
    setTimeout(() => {
      const c = checks[1]
      if (c) {
        c.classList.remove('hide')
        requestAnimationFrame(() => {
          c.classList.add('show', 'done')
        })
      }
    }, 1000)
    setTimeout(() => {
      const c = checks[2]
      if (c) {
        c.classList.remove('hide')
        requestAnimationFrame(() => {
          c.classList.add('show', 'done')
        })
        setProgress(3)
      }
    }, 2000)
  }

  const form = document.getElementById('form')
  const fields = ['name', 'email', 'phone', 'state']
  fillFormFromQueryParams(fields)

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault()

      const invalidInputs = checkSubmitInputs(
        /** @type {HTMLFormElement} */ (form),
      )
      const invalidSelects = checkSubmitSelects(
        /** @type {HTMLFormElement} */ (form),
      )
      if (invalidInputs.length > 0 || invalidSelects.length > 0) {
        const invalid = [...invalidInputs, ...invalidSelects]
        invalid.forEach((el) => {
          el.dispatchEvent(
            new Event('blur', { bubbles: true, cancelable: true }),
          )
        })
        return
      }
      const detail = /** @type {Responses} */ (getDataFromSubmitEvent(e))
      submit(detail)
    })
  }

  /**
   * Submits form.
   * @param {{name: string, email: string, phone: string, state: string}} responses - The form responses
   * @returns {void}
   */
  function submit(responses) {
    /**
     * Collects user data from the `responses` object.
     * @type {SubmitData}
     */
    const data = {
      actively_paying: actively_paying,
      DebtOwed: debtOwed,
      delinquentDays: '',
      email: responses.email,
      Name: `${responses.name}`,
      paymentPlan: '',
      Phone: responses.phone.replace(/\D/g, ''),
      state: responses.state,
      sub1: getQueryParams('sub1') || '',
      sub2: getQueryParams('sub2') || '',
      sub3: getQueryParams('sub3') || '',
      sub4: getQueryParams('sub4') || '',
      sub5: getQueryParams('sub5') || '',
      utm_campaign: getQueryParams('utm_campaign') || '',
      website: 'funnel-cdr',
      funnel: 'funnel-cdr',
    }

    const sessionCache = getFunnelCache(SESSION_ID) || {}

    const params = new URLSearchParams({ ...data, ...sessionCache }).toString()
    const url = `https://funnels.turbodebt.com/my-results/?${params}`
    localStorage.removeItem('TD_CACHE')

    // tell gtm "success happened"
    // @ts-ignore
    window.dataLayer = window.dataLayer || []
    // @ts-ignore
    window.dataLayer.push({
      event: 'lead_submit_success',
      redirect_url: url,
    })

    // small timeout for tag to fire
    setTimeout(() => {
      hide(step4)
      show(step5)
      window.setTimeout(() => {
        window.location.href = url
      }, 6000)
    }, 400)
    return
  }
})

/**
 * Checks all required input fields in the form for validity.
 * @param {HTMLFormElement} form
 * @returns {HTMLElement[]} Array of invalid input elements
 */
function checkSubmitInputs(form) {
  /** @type {HTMLElement[]} */
  const invalidInputs = []

  const inputs = form.querySelectorAll('input[required]')
  inputs.forEach((input) => {
    const inputEl = /** @type {HTMLInputElement} */ (input)
    if (!checkInputValidity(inputEl)) {
      invalidInputs.push(inputEl)
    }
  })
  return invalidInputs
}
/**
 * Checks all required input fields in the form for validity.
 * @param {HTMLFormElement} form
 * @returns {HTMLElement[]} Array of invalid input elements
 */
function checkSubmitSelects(form) {
  /** @type {HTMLElement[]} */
  const invalidSelects = []

  const inputs = form.querySelectorAll('select[required]')
  inputs.forEach((input) => {
    const inputEl = /** @type {HTMLSelectElement} */ (input)
    if (!checkSelectValidity(inputEl)) {
      invalidSelects.push(inputEl)
    }
  })
  return invalidSelects
}
